import { TrackDef } from '../track.js';

/**
 * IONPORT CIRCUIT — Neon Haven, beginner.
 * The classic opener: wide lanes through the harbor district's holo-arches,
 * two banked sweepers, one crest jump over the freight canal.
 */
export const ionport: TrackDef = {
  id: 'ionport',
  name: 'Ionport Circuit',
  tagline: 'Wide harbor streets, forgiving walls, and your first taste of the canal jump.',
  environment: 'neonhaven',
  difficulty: 1,
  layout: 'circuit',
  defaultLaps: 3,
  width: 28,
  unlockLevel: 0,
  points: [
    { x: 0, y: 40, z: 0, width: 30 },
    { x: 10, y: 40, z: 250, width: 30 },
    { x: 60, y: 44, z: 480, width: 28 },
    { x: 220, y: 50, z: 620, width: 26, roll: -0.22 },
    { x: 430, y: 52, z: 600, width: 26, roll: -0.3 },
    { x: 560, y: 46, z: 440, width: 26, roll: -0.22 },
    { x: 580, y: 40, z: 220, width: 28 },
    { x: 500, y: 36, z: 40, width: 24, roll: 0.18 },
    { x: 560, y: 34, z: -180, width: 24, roll: -0.18 },
    { x: 430, y: 40, z: -340, width: 26 },
    { x: 200, y: 50, z: -420, width: 26 },
    { x: -40, y: 46, z: -380, width: 26, roll: 0.25 },
    { x: -170, y: 42, z: -180, width: 28, roll: 0.3 },
    { x: -120, y: 40, z: -20, width: 30 },
  ],
  features: [
    { kind: 'boost', s: 0.05, length: 0.008, lane: 0 },
    { kind: 'boost', s: 0.38, length: 0.007, lane: -0.35 },
    { kind: 'boost', s: 0.55, length: 0.007, lane: 0.3 },
    { kind: 'jump', s: 0.655, length: 0.012 },
    { kind: 'boost', s: 0.82, length: 0.007, lane: 0 },
    { kind: 'zone', s: 0.25, length: 0.1, name: 'arches' },
    { kind: 'zone', s: 0.72, length: 0.09, name: 'canal' },
  ],
  medals: { bronze: 55, silver: 47, gold: 42, author: 39.5 },
};
